const setCssVariables = (variables = {}) => {
    const root = document.documentElement;
    Object.entries(variables).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
  };
  
export default setCssVariables;